import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// The app's own type scale (the `--text-*` tokens in index.css). Unknown to tailwind-merge, it
// would read `text-body1` as a colour and drop it next to `text-fg-*`.
const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            text: [
                'h1',
                'h2',
                'h3',
                'h4',
                'h5',
                'h6',
                'subtitle1',
                'subtitle2',
                'body1',
                'body2',
                'caption',
                'overline',
                'page-title',
                'dialog-title',
                'figure',
                'section',
                'label',
                'meta',
            ],
        },
    },
});

/**
 * Merge Tailwind class names, resolving conflicting utilities so the last one wins.
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
